module.exports = __webpack_public_path__ + "img/logo.ef3ed362.png";